import { render, staticRenderFns } from "./categoryBox.vue?vue&type=template&id=753c7149"
import script from "./categoryBox.vue?vue&type=script&lang=js"
export * from "./categoryBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports